export default "<app-salary-simulation [btnBtnEmail]=\"true\">\n\n</app-salary-simulation>\n"